(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdf-playbook"] && !Shopify.designMode) return;
  try {
    
function initializePlaybook(root) {
  root.querySelectorAll('[data-fdf-playbook]').forEach((page) => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const dialog = page.querySelector('dialog');
    page.querySelectorAll('[data-pb-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
    page.querySelector('[data-pb-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  });
}
initializePlaybook(document);
document.addEventListener('shopify:section:load', event => initializePlaybook(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdf-shred"] && !Shopify.designMode) return;
  try {
    
function initializeShred(root) {
  root.querySelectorAll('[data-fdf-shred]').forEach((page) => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const dialog = page.querySelector('dialog');
    page.querySelectorAll('[data-sp-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
    page.querySelector('[data-sp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  });
}
initializeShred(document);
document.addEventListener('shopify:section:load', event => initializeShred(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdf-statistics"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fdf-statistics')) {
  customElements.define('fdf-statistics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state === 'done') return;
      this.items = Array.from(this.querySelectorAll('[data-final]')).map(node => {
        const final = node.dataset.final.trim();
        const match = final.match(/^([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
        if (!match) return { node, final };
        const decimals = (match[1].split('.')[1] || '').length;
        return { node, final, value: Number(match[1].replace(/,/g, '')), suffix: match[2], format: new Intl.NumberFormat('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: match[1].includes(',') }) };
      });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotion);
      if (this.motion.matches || !('IntersectionObserver' in window)) { this.finish(); return; }
      this.items.forEach(item => { if (Number.isFinite(item.value)) item.node.textContent = item.format.format(0) + item.suffix; });
      this.dataset.state = 'waiting';
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.dataset.state = 'running';
        let start;
        const tick = time => {
          if (start === undefined) start = time;
          const progress = Math.min((time - start) / 1800, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.items.forEach(item => { if (Number.isFinite(item.value)) item.node.textContent = item.format.format(item.value * eased) + item.suffix; });
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else this.finish();
        };
        this.frame = requestAnimationFrame(tick);
      }, { threshold: 0.25 });
      this.observer.observe(this);
    }
    finish() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.items.forEach(item => { item.node.textContent = item.final; });
      this.dataset.state = 'done';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.onMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
